import React, { useContext, useRef, useState } from 'react';
import message from 'antd/lib/message';
import { getAxiosTokenInstance } from '../../utils/axiosInstance';
import { useQuery } from 'react-query';
import { FirebaseContext } from '../../context/FirebaseContext';
import { getDDCSubjects } from '../../NecttosComp/APICaller/ApiServices';
import SearchableImput from '../../NecttosComp/Input/SearchableImput';
import { Body, closeAnimation, Header, Main } from '../../NecttosComp/Layout/Layout';
import Button from '../../NecttosComp/Button/Button';
import Input from '../../NecttosComp/Input/Input';
import { Table, Thead, Th, Tbody, Tr, Td } from '../../NecttosComp/Table/Table';
import Instruction from '../../Documentation/Instruction';

export const DDCSubjects = ({ onClose }) => {
	const { collegeId, collegeList } = useContext(FirebaseContext);
	const componentRef = useRef();
	const selectedCollege = collegeList?.find((x) => x.collegeId === collegeId);
	const [searchTerm, setSearchTerm] = useState('');
	const { data = [], isFetching, refetch } = useQuery('getAllDDCSubjects', getDDCSubjects(collegeId));
	const [isLoading, setIsLoading] = useState(false);
	const [showForm, setShowForm] = useState(false);

	const [state, setState] = useState({
		date: '',
		from: '',
		to: '',
		amount: '',
		naration: '',
	});

	const manageDDCSubject = async () => {
		try {
			setIsLoading(true);
			if (!state.ddcNumber) throw new Error('DDC Number Field Is Empty');
			const instance = await getAxiosTokenInstance();
			const resp = await instance.post('/college/action/postDDCSubjects', {
				collegeId,
				subject: state?.subject,
				ddcNumber: state?.ddcNumber,
				ddcSubject: state?.ddcSubject,
				mainDepartment: state?.mainDepartment,
				relativeDepartment: state?.relativeDepartment,
				_id: state?._id,
			});
			if (resp.data.statusCode !== 200) throw new Error(resp.data.message || 'API Error');
			setState({});
			refetch();
		} catch (error) {
			message.error(error?.response?.data?.message || error?.message || 'API Error');
		} finally {
			setIsLoading(false);
		}
	};

	const filteredUserList = searchTerm ? data.filter((user) => `${user.ddcNumber}${user.subject}`.toLowerCase().includes(searchTerm.toLowerCase())) : data;

	return (
		<Main height='100%' width='100%' title='DDC Management'>
			<Header>
				<div className='flex'>
					<Input width='400px' fieldName='Search by Class Number, Subject' state={searchTerm} setState={setSearchTerm} type='text' />
				</div>
				<div className='flex'>
					<Button
						type='update'
						onClick={() => {
							setState({});
							setShowForm(true);
						}}>
						Add New
					</Button>
					<Button type='fetch' onClick={refetch}>
						Reload
					</Button>
					<Button type='print' tableRef={componentRef.current}>
						Print
					</Button>
					<Instruction keyId={'ddcSubjects'}/>
					{!isLoading && (
						<Button type='close' onClick={onClose}>
							Close
						</Button>
					)}
				</div>
			</Header>

			<Body>
				<div ref={componentRef} className='printable dark:bg-neutral-800 print:bg-white print:text-black rounded-xl relative p-4 overflow-x-auto'>
					<div className='min-w-[800px]'>
						<Table width='100%' innerWidth={['4%', '10%', '20%', '25%', '20%', '20%', '5%']}>
							<Thead>
								<Tr>
									<Th position={0}>Sn</Th>
									<Th position={1}>Class No</Th>
									<Th position={2}>Subject</Th>
									<Th position={3}>Description</Th>
									<Th position={4}>Main Department</Th>
									<Th position={5}>Relative Depts</Th>
									<Th position={6}></Th>
								</Tr>
							</Thead>
							<Tbody height='70vh'>
								{filteredUserList?.map((item, i) => (
									<Tr key={item._id} index={i}>
										<Td position={0} index={i}>
											{i + 1}
										</Td>
										<Td position={1} index={i}>
											{item.ddcNumber}
										</Td>
										<Td position={2} index={i}>
											{item.subject}
										</Td>
										<Td position={3} index={i}>
											{item.ddcSubject}
										</Td>
										<Td position={4} index={i}>
											{item.mainDepartment}
										</Td>
										<Td position={5} index={i}>
											{item.relativeDepartment}
										</Td>
										<Td position={6} index={i}>
											<div className='print:hidden'>
												<Button
													type='edit'
													onClick={() => {
														setState({
															alert: `Edit as ${item.ddcNumber}`,
															ddcNumber: item.ddcNumber,
															subject: item.subject,
															ddcSubject: item.ddcSubject,
															relativeDepartment: item.relativeDepartment,
															mainDepartment: item.mainDepartment,
															_id: item._id,
														});
														setShowForm(true);
													}}>
													Edit
												</Button>
											</div>
										</Td>
									</Tr>
								))}
							</Tbody>
						</Table>
					</div>
				</div>
			</Body>

			{showForm && (
				<div className='fixed inset-0 z-[9999] bg-black/30 backdrop-blur-sm flex items-center justify-center'>
					<Main width='40vw' height='80vh' title={state.alert ? state.alert : 'Add New'}>
						<Header>
							<div className='flex'></div>
							<div className='flex'>
								<Button
									type='close'
									onClick={() => {
										closeAnimation();
										setTimeout(() => setShowForm(false), 500);
									}}>
									Close
								</Button>
							</div>
						</Header>

						<Body>
							<div>
								<SearchableImput keyData='ddcNumber' titleData={<label className='text-base font-medium text-gray-800 dark:text-gray-200'>Classification No</label>} collection='ddcSubjectsLibrary' stateData={state} setStateData={setState} />

								<SearchableImput keyData='subject' titleData={<label className='text-base font-medium text-gray-800 dark:text-gray-200'>Subject</label>} collection='ddcSubjectsLibrary' stateData={state} setStateData={setState} />

								<SearchableImput keyData='ddcSubject' titleData={<label className='text-base font-medium text-gray-800 dark:text-gray-200'>Description</label>} collection='ddcSubjectsLibrary' stateData={state} setStateData={setState} />

								<SearchableImput keyData='mainDepartment' titleData={<label className='text-base font-medium text-gray-800 dark:text-gray-200'>Main Department</label>} collection='ddcSubjectsLibrary' stateData={state} setStateData={setState} />

								<SearchableImput keyData='relativeDepartment' titleData={<label className='text-base font-medium text-gray-800 dark:text-gray-200'>Relative Department</label>} collection='ddcSubjectsLibrary' stateData={state} setStateData={setState} />

								<div className='flex justify-between mt-4'>
									<Button
										type='close'
										onClick={() => {
											setState({
												...state,
												ddcNumber: '',
												subject: '',
												ddcSubject: '',
												mainDepartment: '',
												relativeDepartment: '',
												_id: '',
												alert: '',
											});
										}}>
										Cancel
									</Button>
									<Button type='submit' onClick={manageDDCSubject}>
										Submit
									</Button>
								</div>
							</div>
						</Body>
					</Main>
				</div>
			)}
		</Main>
	);
};
